// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-family:\"light\";src:url(\"/fonts/Poppins-Light.ttf\") format(\"truetype\")}@font-face{font-family:\"regular\";src:url(\"/fonts/Poppins-Regular.ttf\") format(\"truetype\")}@font-face{font-family:\"bold\";src:url(\"/fonts/Poppins-SemiBold.ttf\") format(\"truetype\")}.notification-icon{width:16px;height:16px;display:inline-block;vertical-align:middle;margin:0px 10px 0 2px}", ""]);
// Exports
module.exports = exports;
